import { call, put, takeEvery } from 'redux-saga/effects';
import { SINGLE_SCAN_REQUEST } from '../constants/scanConstants';
import { singleScanFailure, singleScanSuccess } from '../actions/scanActions';
import  {getScanListApi}  from '../api/scanApi';

function* fetchSingleScan(action) {
  try {
    const response = yield call(getScanListApi, action.payload);
    yield put(singleScanSuccess(response));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch single scan list';
    yield put(singleScanFailure(errorMessage));
  }
}

function* singleScanSaga() {
  yield takeEvery(SINGLE_SCAN_REQUEST, fetchSingleScan);
}

export default singleScanSaga;